import "react";
import { jsx as r } from "react/jsx-runtime";
var s = (t) => /* @__PURE__ */ r("svg", {
  fill: "none",
  viewBox: "0 0 16 13",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: /* @__PURE__ */ r("path", {
    d: "m15.1422 1.24264-9.89952 9.89946-4.24264-4.24261",
    stroke: "#fff",
    strokeWidth: 2
  })
});
export {
  s as default
};

//# sourceMappingURL=Checkmark.js.map